import React from 'react';

import MFormContentView from './MFormContent.view';

import { FormikContextType, FormikValues } from 'formik';

type Props<Fields extends FormikValues> = {
  className?: string;
  contentClassName?: string;
  formik: FormikContextType<Fields>;
  isLoading?: boolean;
  isFullScreen?: boolean;
};

const MFormContent = <Fields extends FormikValues>(props: React.PropsWithChildren<Props<Fields>>): JSX.Element => {
  return (
    <MFormContentView
      className={props.className}
      contentClassName={props.contentClassName}
      formik={props.formik}
      isLoading={props.isLoading}
      isFullScreen={props.isFullScreen}
    >
      {props.children}
    </MFormContentView>
  );
};

MFormContent.displayName = 'MFormContent';
MFormContent.defaultProps = {};

export default MFormContent;
